import React from 'react'
import { Dropdown, IDropdownOption, TextField } from 'office-ui-fabric-react'

export function R2B2FloatingForm({
  integrationTypeConfig,
  onIntegrationTypeConfigChange,
  disabled,
  errorCode,
}: {
  integrationTypeConfig: any
  onIntegrationTypeConfigChange: (config: any) => void
  disabled: boolean
  errorCode: string
}) {
  return (
    <>
      <div
        style={{ display: 'grid', gap: '28px', gridTemplateColumns: '1fr 1fr' }}
      >
        <Dropdown
          label="Horizontal Container Position"
          disabled={disabled}
          selectedKey={
            integrationTypeConfig.horizontalContainerPosition || 'right'
          }
          options={[
            { key: 'left', text: 'Left' },
            { key: 'right', text: 'Right' },
          ]}
          onChange={(
            _event: React.FormEvent<HTMLDivElement>,
            item: IDropdownOption | undefined
          ): void => {
            if (!item) return
            onIntegrationTypeConfigChange({
              ...integrationTypeConfig,
              horizontalContainerPosition: item.key as string,
            })
          }}
        />
        <Dropdown
          label="Vertical Container Position"
          disabled={disabled}
          selectedKey={
            integrationTypeConfig.verticalContainerPosition || 'bottom'
          }
          options={[
            { key: 'top', text: 'Top' },
            { key: 'bottom', text: 'Bottom' },
          ]}
          onChange={(
            _event: React.FormEvent<HTMLDivElement>,
            item: IDropdownOption | undefined
          ): void => {
            if (!item) return
            onIntegrationTypeConfigChange({
              ...integrationTypeConfig,
              verticalContainerPosition: item.key as string,
            })
          }}
        />
        <Dropdown
          label="Horizontal Close Button Position"
          disabled={disabled}
          selectedKey={
            integrationTypeConfig.horizontalCloseButtonPosition || 'right'
          }
          options={[
            { key: 'left', text: 'Left' },
            { key: 'right', text: 'Right' },
          ]}
          onChange={(
            _event: React.FormEvent<HTMLDivElement>,
            item: IDropdownOption | undefined
          ): void => {
            if (!item) return
            onIntegrationTypeConfigChange({
              ...integrationTypeConfig,
              horizontalCloseButtonPosition: item.key as string,
            })
          }}
        />
        <Dropdown
          label="Vertical Close Button Position"
          disabled={disabled}
          selectedKey={
            integrationTypeConfig.verticalCloseButtonPosition || 'top'
          }
          options={[
            { key: 'top', text: 'Top' },
            { key: 'bottom', text: 'Bottom' },
          ]}
          onChange={(
            _event: React.FormEvent<HTMLDivElement>,
            item: IDropdownOption | undefined
          ): void => {
            if (!item) return
            onIntegrationTypeConfigChange({
              ...integrationTypeConfig,
              verticalCloseButtonPosition: item.key as string,
            })
          }}
        />
      </div>
      <div
        style={{ display: 'grid', gap: '28px', gridTemplateColumns: '1fr 1fr' }}
      >
        <TextField
          label="Maximum width"
          placeholder="640"
          type="number"
          min={1}
          errorMessage={
            errorCode === 'invalidWidthHeight'
              ? 'Must be a positive number'
              : ''
          }
          value={
            integrationTypeConfig.maxWidth != null
              ? String(integrationTypeConfig.maxWidth)
              : ''
          }
          autoComplete="off"
          disabled={disabled}
          onChange={(
            _event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
            newValue?: string
          ): void => {
            const parsed =
              newValue != null && newValue !== ''
                ? parseInt(newValue, 10)
                : undefined
            onIntegrationTypeConfigChange({
              ...integrationTypeConfig,
              maxWidth: parsed != null && !isNaN(parsed) ? parsed : undefined,
            })
          }}
        />
        <TextField
          label="Maximum height"
          placeholder="480"
          type="number"
          min={1}
          errorMessage={
            errorCode === 'invalidWidthHeight'
              ? 'Must be a positive number'
              : ''
          }
          value={
            integrationTypeConfig.maxHeight != null
              ? String(integrationTypeConfig.maxHeight)
              : ''
          }
          autoComplete="off"
          disabled={disabled}
          onChange={(
            _event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
            newValue?: string
          ): void => {
            const parsed =
              newValue != null && newValue !== ''
                ? parseInt(newValue, 10)
                : undefined
            onIntegrationTypeConfigChange({
              ...integrationTypeConfig,
              maxHeight: parsed != null && !isNaN(parsed) ? parsed : undefined,
            })
          }}
        />
      </div>
      <TextField
        label="Close button text"
        placeholder="Close ad"
        value={integrationTypeConfig.closeButtonText || ''}
        autoComplete="off"
        readOnly={false}
        disabled={disabled}
        onChange={(
          _event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
          newValue?: string
        ): void => {
          onIntegrationTypeConfigChange({
            ...integrationTypeConfig,
            closeButtonText: newValue || '',
          })
        }}
      />
    </>
  )
}
